import { Stack, styled } from '@ltvco/refresh-lib/theme';
import { useSessionEscalation, useSession } from '@ltvco/refresh-lib/v1';

import { Loading } from '../Loading';

import { CheckEmail } from './CheckEmail';
import { Summaries } from './Summaries';

const StyledStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(2, 2.5),
}));

export const GettingStarted = () => {
  const { checkEmail } = useSessionEscalation();

  const {
    session: { account },
  } = useSession();

  const isEnrolled =
    account?.account?.user_settings?.credit_hub_enrollment_completed;

  const display = () => {
    if (checkEmail) {
      return <CheckEmail />;
    }

    if (isEnrolled) {
      return <Loading />;
    }

    return <Summaries />;
  };

  return <StyledStack>{display()}</StyledStack>;
};
